const omit = (prop, { [prop]: _, ...rest }) => rest;

const isDateTypeSupported = () => {
	var input = document.createElement('input');
	var value = 'a';
	input.setAttribute('type', 'date');
	input.setAttribute('value', value);
	return (input.value !== value);
};

const tryParse = (value, defaultValue = 0) => {
    const x = parseFloat(value);
    return isNaN(x) ? defaultValue : x;
}
const onLocalHost = () => ["localhost", "127.0.0.1", ""].includes(window.location.hostname);

export {
    isDateTypeSupported,
    omit,
	tryParse,
	onLocalHost
}